export default __webpack_public_path__ + "static/media/Logo-v2-cropped.8d2a0cdb.png";